import { ReactNode } from 'react';
import { FluentProvider, BrandVariants, createLightTheme, makeStyles } from '@fluentui/react-components';
import classNames from 'classnames';

// https://react.fluentui.dev/?path=/docs/theme-theme-designer--page

export const customBrandRamp: BrandVariants = {
  10: '#020403',
  20: '#121B16',
  30: '#1A2E24',
  40: '#1F3B2D',
  50: '#254937',
  60: '#2A5742',
  70: '#30654C',
  80: '#357457',
  90: '#4A8166',
  100: '#5D8F76',
  110: '#719C85',
  120: '#84A995',
  130: '#97B7A6',
  140: '#ABC5B7',
  150: '#BFD2C7',
  160: '#D3E0D9',
};

const customLightTheme = createLightTheme(customBrandRamp);
// const customDarkTheme = createDarkTheme(customBrandRamp);

type Props = {
  children?: ReactNode;
};

const useStyles = makeStyles({
  root: {
    // background: "radial-gradient(circle at 76% 33%, #e9f0f5 0, #f2f0f4 57%, #f5f5f5 100%)"
  },
});

const ThemeProvider = ({ children }: Props) => {
  const classes = useStyles();
  return (
    <FluentProvider theme={customLightTheme}>
      <div className={classNames('min-h-screen w-full h-screen bg-neutralBg-3', classes.root)}>{children}</div>
    </FluentProvider>
  );
};

// bg-neutralBg-3

export default ThemeProvider;
